export class Schedule {
  /**
   * @param {Object} projectData Object having at least a name and a path for the project
   * @param {String} days
   * @param {Boolean} permanent
   * @param {Number} duration
   * @param {DateTime} dateFrom
   * @param {DateTime} timeFrom
   * @param {DateTime} dateTo
   * @param {DateTime} timeTo
   */
  constructor(
    projectData,
    days,
    permanent,
    duration = 10,
    dateFrom = null,
    timeFrom = null,
    dateTo = null,
    timeTo = null,
    loop_limit = null,
    loop_duration = null
  ) {
    this.projectData = projectData;
    this.days = days;
    this.permanent = permanent;
    this.duration = duration;
    this.dateFrom = dateFrom;
    this.timeFrom = timeFrom;
    this.dateTo = dateTo;
    this.timeTo = timeTo;
    this.loop_limit = loop_limit;
    this.loop_duration = loop_duration;

    ajustDayIfPermanent(this);
  }

  doIPlay() {
    if (this.permanent) {
      return true;
    }
    const currentDate = new Date();
    if (this.dateFrom < currentDate && currentDate > this.dateTo) {
      return true;
    }
    return false;
  }
}

export function createScheduleFromJSON(JSONSchedule) {
  return new Schedule(JSONSchedule.dateFrom, JSONSchedule.dateTo, JSONSchedule.permanent, JSONSchedule.pathToProject);
}

/**
 * Create an array of schedule by giving a list of project with the same period of time.
 * @param {Object created after creating a new schedule} scheduleList
 */
/*
export function createScheduleFromList(scheduleList) {
  //const dateFrom = scheduleList.
}
*/

export function CreateNewSchedule(pName, days, isPerma, dtFrom = null, tFrom = null, dtTo = null, tTo = null) {
  return new Schedule(pName, days, isPerma, dtFrom, tFrom, dtTo, tTo);
}

function ajustDayIfPermanent(schedule) {
  // override weekday because isPermanent is true
  if (schedule.permanent) {
    schedule.days = [
      {
        day: "monday",
        active: true,
      },
      {
        day: "tuesday",
        active: true,
      },
      {
        day: "wednesday",
        active: true,
      },
      {
        day: "thursday",
        active: true,
      },
      {
        day: "friday",
        active: true,
      },
      {
        day: "saturday",
        active: true,
      },
      {
        day: "sunday",
        active: true,
      },
    ];
  }
}

export function CreateEmptySchedule() {
  return CreateNewSchedule("", [], true);
}
